/**
 * @fileoverview DELETE handler for the "/custom_objects/:type_name/schema/fields/:field_name" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameSchemaFieldsFieldNameCacheKeys } from "./constants";
import type { DeleteCustomObjectsTypeNameSchemaFieldsFieldNameProps } from "./types";

export const deleteCustomObjectsTypeNameSchemaFieldsFieldName = reactQueryMutationAdapter(
  [...customObjectsTypeNameSchemaFieldsFieldNameCacheKeys],
  ({
    appGroupId,
    typeName,
    fieldName,
  }: DeleteCustomObjectsTypeNameSchemaFieldsFieldNameProps): Promise<Record<string, never>> => {
    return fetch(
      `/custom_objects/${encodeURIComponent(typeName)}/schema/fields/${encodeURIComponent(fieldName)}`,
      "DELETE",
      { app_group_id: appGroupId },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
